<template>
  <el-upload class="avatar-uploader" :action="upload" :show-file-list="false" :on-success="onAvatarSuccess"
    :before-upload="beforeAvatarUpload" :headers="uploadHeaders">
    <el-button class="button" size="small" type="primary" icon="el-icon-upload2">{{ name }}</el-button>
  </el-upload>
</template>

<script type="text/javascript">
  export default {
    components: {},
    props: {
      name: {
        type: String,
      },
      // 文件上传路径
      upload: {
        type: String,
        required: true
      },
      types: {
        type: Array,
        default: () => ['xls', 'xlsx']
      },
      maxSize: {
        type: Number,
        default: 10
      }
    },
    data() {
      return {
        uploading: false, //文件上传中
      }
    },
    methods: {
      onAvatarSuccess(res, file) {
        this.$emit("uploaded", res, file);
      },
      beforeAvatarUpload(file) {
        var self = this;
        this.$emit('beforeUpload')
        let typeIsOk = self.types.length == 0;
        const sizeIsOk = file.size / 1024 / 1024 < self.maxSize;
        for (let i = 0; i < self.types.length; i++) {
          switch (self.types[i]) {
            case "xls":
              typeIsOk = typeIsOk || file.type == "application/vnd.ms-excel";
              break;
            case "xlsx":
              typeIsOk = typeIsOk || file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
              break;
            default:
              break;
          }
        }
        if (!typeIsOk) {
          var types = "[ ";
          self.types.forEach(type => {
            types += types == "[ " ? type : ', ' + type;
          });
          types += " ]";
          self.$message.error('文件格式不支持!\n仅支持 ' + types + ' 等文件格式。');
        }
        else if (!sizeIsOk) {
          self.$message.error('文件大小不能超过 ' + self.maxSize + 'MB!');
        }
        return typeIsOk && sizeIsOk;
      }
    },
    computed:{
      uploadHeaders(){
        var token = localStorage.ms_token;
        return { Authorization: 'Bearer ' + token };
      }
    }
  }

</script>

<style type="text/css" scoped>
  .el-upload-tip {
    margin-left: 10px;
  }
  .avatar-uploader {
    display: inline-block;
  }

  .el-button+.avatar-uploader {
    margin-left: 10px;
  }
  .avatar-uploader+.el-button {
    margin-left: 10px;
  }
  .el-button-group>.avatar-uploader:not(:first-child):not(:last-child) .button {
    border-radius: 0;
    border-left-color: rgba(255,255,255,.5);
    border-right-color: rgba(255,255,255,.5);
  }
  .el-button-group>.avatar-uploader:last-child .button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left-color: rgba(255,255,255,.5);
  }
  .el-button-group>.avatar-uploader:first-child .button {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right-color: rgba(255,255,255,.5);
  }
  .el-button-group>.avatar-uploader:not(:last-child) {
      margin-right: -1px;
  }
  .el-button-group>.el-button+.avatar-uploader {
      margin-left: 0;
  }
  .el-button-group>.avatar-uploader+.el-button {
      margin-left: 0;
  }
  .el-button-group>.avatar-uploader {
      float: left;
      position: relative;
  }

</style>



// WEBPACK FOOTER //
// src/tycomponents/Upload/TyImport.vue